const retreatStateFliter = function(input) {
  // 0--未提报1-提报待受理2-提报待调度受理3-提报内部拒绝4-提报调度拒绝5-提报通过10-退订通过
    switch (input) {
      case '6':
        return '待受理'
      case '7':
        return '待受理'
      case '8':
        return '已拒绝'
      case '9':
        return '已拒绝'
      case '10':
        return '受理通过'
    }
}
let filterObj = {}
filterObj.retreatState = retreatStateFliter
export default filterObj
